import { memo, useEffect, useState } from "react";
import { Button, Checkbox, Popconfirm, Space, Table, TableProps, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { mdlTablePagination } from "../../../models/ui-models/TablePagination";
import { QuestionCircleOutlined } from '@ant-design/icons';
import { mdlHotelNotConfirm } from "../../../models/domain/HotelNotConfirm";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { mdlNotConfirm } from "../../../models/domain/NotConfirm";

export type NotConfirmTableProps = {
    fnSelectAll?: any;
    onTableItemSelect?: any;
    tableItems?: mdlHotelNotConfirm[];
    onDelete?: (record: mdlNotConfirm) => void;
    pagination: mdlTablePagination;
    onTableParamsChange?: Function;
    selectedHotel?:string;
    rowSelectionChange?: Function;
}

export const NotConfirmTable = memo(function NotConfirmTable(props: NotConfirmTableProps) {
    const { t } = useTranslation();
    const [selectionType, setSelectionType] = useState<'checkbox' | 'radio'>('checkbox');

    useEffect(() => {
    }, [props]);
    
    const rowSelection: TableProps<mdlHotelNotConfirm>['rowSelection'] = {
        onChange: (selectedRowKeys: React.Key[], selectedRows: mdlHotelNotConfirm[]) => {
            props.rowSelectionChange && props.rowSelectionChange(selectedRows);
        },
    };

    const columns: TableProps<mdlHotelNotConfirm>['columns'] = [     
        {
            title: t("definitions.notConfirm.code"),
            dataIndex: 'code',
            key: 'code'
        },
        {
            title: t("definitions.notConfirm.name"),
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: t("common.actions"),
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Popconfirm
                        title={t("common.deleteWarning")}
                        description={t("common.deleteDescription")}
                        okText={t("common.okConfirm")}
                        cancelText={t("common.cancelConfirm")}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        onConfirm={() => props.onDelete ? props.onDelete(record) : undefined}
                    >
                        <Button type="primary" danger>
                            {t("common.delete")}
                        </Button>
                    </Popconfirm>

                </Space>
            ),
        },
    ];

    const handleTableChange: TableProps<mdlHotelNotConfirm>['onChange'] = (pagination, filters, sorter) => {
        props.onTableParamsChange && props.onTableParamsChange(pagination, filters);
    }

    return (
        <>
        <div className="row">
            {
                props.tableItems
                &&
                <div className="col-sm-12">
                    <Table<mdlHotelNotConfirm>
                        onChange={handleTableChange}
                        size="middle"
                        columns={columns}
                        pagination={props.pagination}
                        scroll={{ x: 'max-content' }}
                        dataSource={props.tableItems.map((data: mdlHotelNotConfirm, index: number) => ({ ...data, key: index }))}
                        rowSelection={{ type: selectionType, ...rowSelection }}
                    />
                </div>
            }
            
            {
                !props.tableItems
                &&
                <div className="col-sm-12">
                    <div className="alert alert-warning alert-icon">
                        <FontAwesomeIcon icon={ faWarning } />
                        <span className="ps-4">{t('notConfirm.mustChooseHotel')}</span>
                    </div>
                </div>
            }
        </div>
        </>
    )
})